module.exports = __webpack_public_path__ + "img/iconWhatsappGray.6dd1273c.svg";